import React, { Component } from "react";

import { Card, Button, Table, Tooltip, Select, Input, BackTop } from "antd";

import { connect } from "react-redux";
import {
  req_page_slm_class_statistics,
  req_downloadfile_slm_class_statistics,
} from "../../api";

import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
//import { formateDate } from '../../utils/dateUtil'

class ClassLiveList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",
    //responseYearSurveyCode: '',

    /*特定參數*/
    searchFieldExtA: "NONE",
    searchFieldExtB: "NONE",
    searchFieldExtC: "NONE",
    searchFieldExtD: "",
    searchFieldExtE: "",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
    } = this.state;
    const { token, userCode, role } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_slm_class_statistics(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE,
    } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_slm_class_statistics(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      token,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
      searchFieldExtE
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "畢業135年校友清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "部別",
        dataIndex: "DivisionTwName",
        width: 40,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學制",
        dataIndex: "EducationalSystemTwName",
        width: 40,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學院",
        dataIndex: "CollegeTwName",
        width: 40,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "系所",
        dataIndex: "DepartmentTwName",
        width: 80,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "班級",
        dataIndex: "ClassroomTwName",
        width: 40,
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "",
        dataIndex: "",
        width: 65,
        render: (item) => {
          const {
            StudentTotal,
            NoneTotal,
            NeedOutreachTotal,
            TutorWaitConfirmTotal,
          } = item;
          return (
            <>
              <div className="text-center">
                <Button size="small">
                  全班總人數：{this.add_zero(StudentTotal)}
                </Button>
                <Button
                  size="small"
                  style={{
                    backgroundColor: NoneTotal > 0 ? "MistyRose" : "White",
                  }}
                >
                  未回報人數：{NoneTotal > 0 ? this.add_zero(NoneTotal) : "00"}
                </Button>
                <div></div>
                <Button
                  size="small"
                  style={{
                    backgroundColor:
                      NeedOutreachTotal > 0 ? "LightCyan" : "White",
                  }}
                >
                  應宣教人數：
                  {NeedOutreachTotal > 0
                    ? this.add_zero(NeedOutreachTotal)
                    : "00"}
                </Button>
                <Button
                  size="small"
                  style={{
                    backgroundColor:
                      TutorWaitConfirmTotal > 0 ? "LemonChiffon" : "White",
                  }}
                >
                  待訪視人數：
                  {TutorWaitConfirmTotal > 0
                    ? this.add_zero(TutorWaitConfirmTotal)
                    : "00"}
                </Button>
              </div>
            </>
          );
        },
      },
    ];
  };

  style_switch_color_tag(column, param) {
    switch (column) {
      case "NoneTotal":
        break;
      case "NeedOutreachTotal":
        break;
      case "TutorWaitConfirmTotal":
        break;
      default:
        break;
    }
  }

  add_zero(i) {
    return i < 10 ? "0" + i : i;
  }
  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  /////////////////////////////////////////////////////////////

  render() {
    const {
      deviceWidth,
      loading,
      items,
      pagination,
      searchField,
      searchValue,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      searchFieldExtD,
    } = this.state;
    const title = (
      <span>
        {deviceWidth > 1200 ? (
          <>
            <Select
              value={searchFieldExtA}
              style={{ width: 120 }}
              onChange={(value) => this.setState({ searchFieldExtA: value })}
            >
              <Select.Option value="NONE">部別</Select.Option>
              <Select.Option value="A">日間部</Select.Option>
              <Select.Option value="B">進修部</Select.Option>
              <Select.Option value="C">推廣教育</Select.Option>
              <Select.Option value="D">教育學程</Select.Option>
              <Select.Option value="E">假日專班</Select.Option>
              <Select.Option value="F">特殊專班</Select.Option>
            </Select>
            <Select
              value={searchFieldExtB}
              style={{ width: 140 }}
              onChange={(value) => this.setState({ searchFieldExtB: value })}
            >
              <Select.Option value="NONE">學院</Select.Option>
              <Select.Option value="0DA00">民生暨管理學院</Select.Option>
              <Select.Option value="0DD00 ">設計學院</Select.Option>
              <Select.Option value="0DE00">藝術學院</Select.Option>
            </Select>
            <Select
              value={searchFieldExtC}
              style={{ width: 120 }}
              onChange={(value) => this.setState({ searchFieldExtC: value })}
            >
              <Select.Option value="NONE">學制</Select.Option>
              <Select.Option value="A">七年一貫制</Select.Option>
              <Select.Option value="E">二年制</Select.Option>
              <Select.Option value="C">四年制</Select.Option>
              <Select.Option value="D">四技專班</Select.Option>
              <Select.Option value="I">貳年制</Select.Option>
              <Select.Option value="H">肆年制</Select.Option>
              <Select.Option value="J">碩士班</Select.Option>
              <Select.Option value="K">碩士專班</Select.Option>
              <Select.Option value="M">學分班</Select.Option>
            </Select>
            <Input
              placeholder="科系"
              style={{ width: 150, margin: "0 5px" }}
              value={searchFieldExtD}
              onChange={(event) =>
                this.setState({ searchFieldExtE: event.target.value })
              }
            />
          </>
        ) : (
          ""
        )}
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索其他條件</Select.Option>
          <Select.Option value="TutorTwName">導師姓名</Select.Option>
          <Select.Option value="InstructorTwName">教官姓名</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search"></i>
          <span style={{ marginLeft: "4px" }}>
            {" "}
            {deviceWidth > 600 ? "查詢" : ""}
          </span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        {deviceWidth > 600 ? (
          <>
            <Button type="primary" onClick={() => this.handle_data_download()}>
              <i className="fas fa-cloud-download-alt element-hidden"></i>
              <span style={{ marginLeft: "4px" }}> 下載</span>
            </Button>
          </>
        ) : (
          ""
        )}
      </span>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="ClassroomCode"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(ClassLiveList);
